import { render, staticRenderFns } from "./Catering.vue?vue&type=template&id=afc24d48&"
import script from "./Catering.vue?vue&type=script&lang=js&"
export * from "./Catering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports